import { COOKIE_NAME_PREFIX } from "@constants/cookies";
import { TokenData } from "@models/TokenData";
import { UserData } from "@models/UserData";
import getCookie from "../utils/cookies/getCookie";
import removeCookie from "../utils/cookies/removeCookie";
import setCookie from "../utils/cookies/setCookie";

const ACCESS_TOKEN_COOKIE = `${COOKIE_NAME_PREFIX}access_token`;
const ID_TOKEN_COOKIE = `${COOKIE_NAME_PREFIX}id_token`;
const REFRESH_TOKEN_COOKIE = `${COOKIE_NAME_PREFIX}refresh_token`;
const SUB_COOKIE = `${COOKIE_NAME_PREFIX}sub`;
const EMAIL_COOKIE = `${COOKIE_NAME_PREFIX}email`;

export function storeTokens(data: TokenData) {
  setCookie(ACCESS_TOKEN_COOKIE, data.access_token);
  setCookie(ID_TOKEN_COOKIE, data.id_token);
  setCookie(REFRESH_TOKEN_COOKIE, data.refresh_token);
}

export function storeUserData(data: UserData) {
  setCookie(SUB_COOKIE, data.sub);
  setCookie(EMAIL_COOKIE, data.email);
}

export function deleteTokens() {
  removeCookie(ACCESS_TOKEN_COOKIE);
  removeCookie(ID_TOKEN_COOKIE);
  removeCookie(REFRESH_TOKEN_COOKIE);
  removeCookie(SUB_COOKIE);
}

export function retrieveUserData(): UserData | undefined {
  const sub = getCookie(SUB_COOKIE);
  const email = getCookie(EMAIL_COOKIE);

  if (sub && email) {
    return {
      sub,
      email,
    };
  }

  return undefined;
}

export function retrieveTokens(): TokenData | undefined {
  const acc = getCookie(ACCESS_TOKEN_COOKIE);
  const id = getCookie(ID_TOKEN_COOKIE);
  const ref = getCookie(REFRESH_TOKEN_COOKIE);

  if (acc && id && ref) {
    return {
      access_token: acc,
      id_token: id,
      refresh_token: ref,
    };
  }

  return undefined;
}
